module.exports = __webpack_public_path__ + "media/img/logos/loreal-b349440bd0c0f0350150202020a93754.svg";